/* Common Imports */

import { styled } from "@mui/system";
import React from "react";

/* Redux Imports */

import {
	AddingBeegruPointsForSharePropertyThunk,
	AddingBeegruPointsForShareServiceThunk,
	CreateNewSharesThunk,
} from "../../redux-magic/thunks";

/* Component Imports */

import {
	Alert,
	Dialog,
	DialogContent,
	DialogTitle,
	Divider,
	IconButton,
	Link,
	Snackbar,
	SvgIcon,
	Typography,
	useTheme,
} from "@mui/material";
import { useRouter } from "next/router";

/* Icon Imports */

import { Close } from "@mui/icons-material";
import { ObjectId } from "bson";
import MailIcon from "../../public/images/icons/social/mail-new.svg";
import CopyIcon from "../../public/images/icons/social/new_copy.svg";
import WhatsAppIcon from "../../public/images/icons/social/whatsapp-icon.svg";
import StateInterface from "../../redux-magic/state-interface";

/* Styled Components */

const CustomDialog = styled(Dialog)(({ theme }) => ({
	padding: "1rem ",
	"& .MuiDialog-paper": {
		borderRadius: "16px",
		overflow: "hidden",
		[theme.breakpoints.down("sm")]: {
			margin: "0rem",
			width: "100%",
		},
	},
}));

const CustomDialogTitle = styled(DialogTitle)(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
	alignItems: "center",
	width: "100%",
	padding: "0.5rem 1rem 0.5rem 1rem",
	background: theme.palette.background.paper,
}));

const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "space-between",
	alignItems: "center",
	width: "100%",
	padding: "2rem 1rem 1rem 1rem",
	background: theme.palette.background.paper,
	gap: "1rem",
}));

// const CustomDialogActions = styled(DialogActions)(({ theme }) => ({
//   display: "flex",
//   flexDirection: "row",
//   justifyContent: "flex-end",
//   alignItems: "center",
//   width: "100%",
//   gap: "1rem",
//   padding: "0rem 1rem 1rem 0rem",
//   background: theme.palette.mode === "dark" ? "#212B36" : "#FFFFFF",
// }));

const SocialButtonsConatiner = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-around",
	alignItems: "flex-start",
	width: "100%",
	margin: "0rem 0rem 0rem 0rem",
}));

const SocialPaper = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "center",
	height: "4.5rem !important",
	width: "4.5rem !important",
	gap: "0.5rem",
	margin: "0.5rem 0rem 0.5rem 0rem",
	borderRadius: "8px",
	cursor: "pointer",
	"@media (pointer:fine)": {
		"&:hover": {
			scale: "1.1",
		},
	},
}));

// const CopyRow = styled("div")(({ theme }) => ({
// 	display: "flex",
// 	flexDirection: "row",
// 	alignItems: "center",
// 	justifyContent: "center",
// 	// marginTop: "1.5rem",
// 	marginBottom: "0rem",
// 	width: "100%",
// 	[theme.breakpoints.down("sm")]: {
// 		width: "100% !important",
// 		padding: "0rem",
// 	},
// }));

// const CopyInput = styled(TextField)(({ theme }) => ({
// 	width: "100%",
// 	margin: 0,
// 	height: "3.5rem",
// 	borderRadius: "5px 0px 0px 5px",
// 	[theme.breakpoints.down("sm")]: {
// 		height: "3.5rem !important",
// 	},
// }));

const Snack = styled(Snackbar)(({ theme }) => ({
	[theme.breakpoints.down("md")]: {
		bottom: "5rem",
		borderRadius: "0.5rem",
	},
}));

const Label = styled(Typography)(({ theme }) => ({}));

const ShareModal = ({
	open,
	handleClose,
	url,
	dispatch,
	session,
	entity,
	creator_user_id,
	entity_created_by,
	entity_id,
	profile_context,
}: {
	open: boolean;
	handleClose: any;
	url: string;
	dispatch: Function;
	session: StateInterface["redux_session"];
	entity?: string;
	creator_user_id?: string | ObjectId;
	entity_created_by?: any;
	entity_id?: string | ObjectId;
	profile_context?: StateInterface["profile_context"];
}) => {
	const theme = useTheme();
	const [openSnackbar, setOpenSnackbar] = React.useState(false);

	const handleclickCopy = (url: string) => {
		navigator.clipboard.writeText(url);
		setOpenSnackbar(true);
	};

	const handleCloseSnackbar = (event: any, reason: any) => {
		if (reason === "clickaway") {
			return;
		}
		setOpenSnackbar(false);
	};

	const router = React.useRef(useRouter()).current;

	const entityKannada: string =
		entity === "property"
			? "ಈ ಪ್ರಾಪರ್ಟಿಯನ್ನು"
			: entity === "post"
				? "ಈ ಪೋಸ್ಟ್"
				: entity === "profile"
					? "ಈ ಏಜೆಂಟನ್ನು"
					: entity === "service"
						? "ಈ ಸೇವೆಯನ್ನು"
						: entity === "User"
							? "ಈ ಯೂಸರ್ ಅನ್ನು"
							: "";

	const localLang = {
		shareThis:
			router.locale === "ar-AE"
				? ""
				: router.locale === "kn-IN"
					? entityKannada + " ಹಂಚಿಕೊಳ್ಳಿ"
					: "Share this " + entity,
		share: router.locale === "ar-AE" ? "" : router.locale === "kn-IN" ? "ಹಂಚಿಕೊಳ್ಳಿ" : "Share",
		email: router.locale === "ar-AE" ? "" : router.locale === "kn-IN" ? "ಇ-ಮೆಲ್" : "Email",
		whatsapp: router.locale === "ar-AE" ? "" : router.locale === "kn-IN" ? "ವಾಟ್ಸಪ್" : "WhatsApp",
		copy: router.locale === "ar-AE" ? "" : router.locale === "kn-IN" ? "ನಕಲಿಸಿ" : "Copy",
		copylink:
			router.locale === "ar-AE" ? "" : router.locale === "kn-IN" ? "ಅಥವಾ ಈ ಲಿಂಕನ್ನು ನಕಲಿಸಿ" : "or copy this link",
		linkCopied: router.locale === "ar-AE" ? "" : router.locale === "kn-IN" ? "ಲಿಂಕ್ ನಕಲಿಸಲಾಗಿದೆ" : "Link Copied",
	};

	const property: boolean = router.asPath.includes("properties");

	const service: boolean = router.asPath.includes("services");

	const handleShareClick = async () => {
		if (session?.user?.dbUser?._id === creator_user_id) {
			if (property) {
				await dispatch(
					AddingBeegruPointsForSharePropertyThunk({
						user_id: session?.user?.dbUser?._id || "",
						url: router.asPath ? router.asPath : "",
					}),
				);
			}

			await dispatch(
				AddingBeegruPointsForShareServiceThunk({
					user_id: session?.user?.dbUser?._id || "",
					url: router.asPath ? router.asPath : "",
					sessionId: session ? (session.session_id ? session.session_id : "") : "",
				}),
			);
		}
	};

	const handleShare = async (url: string, source: string) => {
		dispatch(
			CreateNewSharesThunk({
				entity_type: entity ? entity : "property",
				entity_id: entity_id ? entity_id : "",
				shared_through: source,
				entity_created_by: {
					user_id:
						entity && entity === "business_profile"
							? entity_created_by
							: entity_created_by
								? entity_created_by.user_id
									? entity_created_by.user_id._id
									: entity_created_by.user_id
								: "",
					business_profile_id:
						entity && entity === "business_profile"
							? entity_created_by
							: entity_created_by
								? entity_created_by.business_profile_id
									? entity_created_by.business_profile_id._id
									: entity_created_by.business_profile
								: "",
					is_business_profile:
						entity && entity === "business_profile"
							? true
							: entity_created_by
								? entity_created_by.is_business_profile
								: false,
				},
				is_guest: session ? false : true,
				logged_user:
					session && profile_context
						? {
								user_id: profile_context ? profile_context.user_id : "",
								business_profile_id: profile_context ? profile_context.business_profile_id : "",
								is_business_profile: profile_context ? profile_context.is_business_profile : false,
							}
						: null,
			}),
		);
	};

	return (
		<React.Fragment>
			{/* Snackbar */}

			<Snack
				open={openSnackbar}
				autoHideDuration={3000}
				onClose={handleCloseSnackbar}
				anchorOrigin={{ vertical: "top", horizontal: "center" }}
			>
				<Alert
					onClose={(e) => {
						handleCloseSnackbar(e, "");
					}}
					severity="success"
					sx={{ width: "100%", borderRadius: "0.75rem" }}
					variant="filled"
				>
					{localLang.linkCopied}
				</Alert>
			</Snack>

			{/* Share Modal */}

			<CustomDialog
				onClose={handleClose}
				open={open}
				maxWidth="xs"
				fullWidth={true}
				disableScrollLock={true}
			>
				<CustomDialogTitle>
					{entity ? localLang.shareThis : localLang.share}
					<IconButton
						aria-label="close"
						onClick={handleClose}
					>
						<Close />
					</IconButton>
				</CustomDialogTitle>

				<CustomDialogContent>
					<SocialButtonsConatiner>
						{/* Whatsapp */}

						<Link
							href={"https://wa.me/?text=Have a look at this service on Beegru " + url + "?source=whatsapp"}
							rel="noopener"
							target="_self"
							referrerPolicy="no-referrer"
							aria-label="Share via Whatsapp"
							sx={{ textDecoration: "none", color: "inherit" }}
							onClick={() => {
								session !== null ? (property || service ? handleShareClick() : null) : null;
								handleShare(url, "whatsapp");
							}}
						>
							<SocialPaper>
								<SvgIcon
									component={WhatsAppIcon}
									inheritViewBox={false}
									viewBox="0 0 24 24"
									width={24}
									height={24}
									sx={{
										width: "2rem",
										height: "2rem",
									}}
								/>
								<Label variant="body2">{localLang.whatsapp}</Label>
							</SocialPaper>
						</Link>

						<Divider
							orientation="horizontal"
							flexItem
							sx={{
								width: "1px",
								margin: "1rem 0",
								backgroundColor: theme.palette.divider,
							}}
						/>

						{/* Email */}

						<Link
							href={
								"mailto:?&subject=Have%20a%20look%20at%20this%20service%20on%20Beegru.&body=" +
								encodeURIComponent(url) +
								"?source=email"
							}
							rel="noopener"
							target="_self"
							referrerPolicy="no-referrer"
							aria-label="Share via Email"
							sx={{ textDecoration: "none", color: "inherit" }}
							onClick={() => {
								session !== null ? (property || service ? handleShareClick() : null) : null;
								handleShare(url, "email");
							}}
						>
							<SocialPaper>
								<SvgIcon
									component={MailIcon}
									inheritViewBox={false}
									viewBox="0 0 24 24"
									width={24}
									height={24}
									sx={{
										width: "2rem",
										height: "2rem",
									}}
								/>
								<Label variant="body2">{localLang.email}</Label>
							</SocialPaper>
						</Link>

						{/* Divider */}

						<Divider
							orientation="horizontal"
							flexItem
							sx={{
								width: "1px",
								margin: "1rem 0",
								backgroundColor: theme.palette.divider,
							}}
						/>

						{/* Copy */}

						<SocialPaper>
							<IconButton
								onClick={(e: any) => {
									handleclickCopy(url + "?source=copy");
									session !== null ? (property || service ? handleShareClick() : null) : null;
									handleShare(url, "copy");
								}}
								sx={{
									height: "2.5rem",
									width: "2.5rem",
									borderRadius: "0.5rem",
									color: "#B05911",
									padding: "0.5rem",
								}}
								size="medium"
							>
								<SvgIcon
									component={CopyIcon}
									inheritViewBox={false}
									viewBox="0 0 25 25"
									width={24}
									height={24}
									sx={{
										width: "2rem",
										height: "2rem",
									}}
								/>
							</IconButton>
							<Label variant="body2">{localLang.copy}</Label>
						</SocialPaper>
					</SocialButtonsConatiner>

					{/* <CopyRow>
						<CopyInput
							id="copyText"
							label={localLang.copylink}
							value={url}
							variant="outlined"
							InputProps={{
								readOnly: true,
							}}
						/>
					</CopyRow> */}
				</CustomDialogContent>
			</CustomDialog>
		</React.Fragment>
	);
};

export default ShareModal;
